import { Box, Typography, makeStyles, TableContainer, Paper, TableHead, Table, TableRow, TableCell, TableBody, Collapse, CircularProgress } from '@material-ui/core'
import React, { useRef } from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import { grey } from '@material-ui/core/colors';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';




const useStyles = makeStyles((theme) => ({
    root: {
        margin: "10px 0px"
    }

}));

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

const Row = ({ word }) => {

    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    const options = { month: "numeric", day: "numeric", year: "numeric" }
    const dateLearn = new Date(word.dateLearned);
    const dateLastTest = new Date(word.lastTested);
    const audioFile = useRef(null);

    const renderExampleChildren = (examples) => {
        let  count = 0;
        return examples.map(ele => 
            { 
                return <Typography key={`${word.word.word} ${count++}`} variant='body2'>{ele} <br /><br /></Typography> 
            }
        );

    }

    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {word.word.word}
                </TableCell>
                <TableCell align="right">{word.word.partOFSpeech}</TableCell>
                <TableCell align="right">{dateLearn.toLocaleDateString(undefined, options)}</TableCell>
                <TableCell align="right">{dateLastTest.toLocaleDateString(undefined, options)}</TableCell>
                <TableCell align="right">{word.netProfit}</TableCell>
                <TableCell align="right">{word.proficiency}</TableCell>

            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: grey[700] }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="body2" gutterBottom >
                                Definition
                            </Typography>
                        </Box>
                    </Collapse>
                </TableCell >
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: grey[700] }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <IconButton color='primary' onClick={() => audioFile.current.play()}>
                                <VolumeUpIcon />
                                <audio ref={audioFile} src={word.word.audioURL} > </audio>

                            </IconButton>
                        </Box>
                    </Collapse>
                </TableCell >
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: grey[700] }} colSpan={5}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="body2" gutterBottom>
                                {word.word.definition}
                            </Typography>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
            <TableRow>

                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: grey[700] }} colSpan={1}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="body2" gutterBottom >
                                Examples
                            </Typography>
                        </Box>
                    </Collapse>
                </TableCell >

                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: grey[700] }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            {renderExampleChildren(word.word.examples)}
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>


        </React.Fragment>
    )

}



const TableMdUpScreen = ({ wordBank }) => {
    const classes = useStyles();
    if (wordBank === null) {
        return <CircularProgress />
    }
    if (wordBank.length === 0) return null;
    return (
        <TableContainer className={classes.root} component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell > Word</TableCell>
                        <TableCell align="right"> Part Of Speech</TableCell>
                        <TableCell align="right"> Date Learned</TableCell>
                        <TableCell align="right"> Last Tested</TableCell>
                        <TableCell align="right"> Profit</TableCell>
                        <TableCell align="right"> Proficiency</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {wordBank.map((word) => (


                        <Row key={word.word.word} word={word} />
                    ))}
                </TableBody>
            </Table>

        </TableContainer>

    )
}

export default TableMdUpScreen
